<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { LayerListItemManager } from "./LayerListItemManager";
    export let manager: LayerListItemManager;

    const modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    const layer = manager.getLayerAndStatus();
    const enabled = layer.enabled;
    const visible = layer.visible;
    
    const locationizationKey = (layer.layer?.properties ?? {})["localization_key"] ?? `by_${layer.vehicle.key}`;
</script>

<div
    class="list-group-item list-group-item-action border-0 p-5 py-3"
    aria-current="true">
    <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">{$_(`${$modelTranslationKeyStore}.layers.${locationizationKey}.title`)}</h5>
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" bind:checked={$visible} disabled={!$enabled}/>
        </div>
    </div>
    <!-- <p class="mb-1">{$_(`layers.${locationizationKey}.subtitle`)}</p>  -->
    <p class="text-muted mb-0"><small>{$_(`${$modelTranslationKeyStore}.layers.${locationizationKey}.description`)}</small></p>
</div>
